import React from 'react';
import './../../styles/css/search.css';
import { SessionState } from './ISearch';
type IProps = {
  label: string;
  index: number;
  deleteCallback: (index: number) => void;
};

const translateStatusEnum = (value: string): string => {
  switch (value) {
    case SessionState.DELETED:
      return 'IZBRISANO';
    case SessionState.INITIALIZING:
      return 'V PRIPRAVI';
    case SessionState.IN_QUEUE:
      return 'V VRSTI';
    case SessionState.IN_PROGRESS:
      return 'V PROCESIRANJU';
    case SessionState.FINISHED:
      return 'UREDI';
    case SessionState.CANCELED:
      return 'PREKINJENO';
    case SessionState.ERROR:
      return 'NAPAKA';
    default:
      return value;
  }
};

const SearchToken = ({ label, index, deleteCallback }: IProps) => {
  return (
    <div className="searchToken" onClick={() => deleteCallback(index)}>
      <span> {translateStatusEnum(label)}</span>
    </div>
  );
};

export default SearchToken;
